import { Navigate, Outlet } from 'react-router-dom';

import { useAppSelector } from '../store';

export const PublicRoute = () => {
  const isLoggedIn = useAppSelector((state) => state.auth.isLoggedIn);
  if (isLoggedIn) {
    return <Navigate to="/" replace />;
  }
  return <Outlet />;
};
